import { Navbar } from "./Navbar";

export const PageLayout = ({ children, className = "" }) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {/* pt-16 for mobile header, lg:pt-0 for desktop; mr for sidebar on desktop only */}
      <main className={`pt-16 lg:pt-0 lg:mr-64 ${className}`}>
        {children}
      </main>
    </div>
  );
};
